<template>
  <div>
    <Label v-bind="labelProps" :disabled="disabled" :html-for="id" :bold="labelBold" v-if="label">
      {{ label }}
    </Label>
    <money
      v-model="localValue"
      v-bind="formatOptions"
      class="form-control input"
      :id="id"
      :class="inputClass"
      :placeholder="placeholder"
      :disabled="disabled"
      :error="error"
      :maxlength="max + currentPrecison"
      @keydown.native="$event.key === '-' && $event.preventDefault()"
      @keyup.native="keyupHandler"
    />
    <div class="input-description input-margin" v-if="description" :class="descriptionClass">
      {{ description }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Label from './Label';
import { numberBRToFloat } from '../../core/helpers/formater/number';

export default {
  name: 'InputMoney',
  components: {
    Label,
  },
  props: {
    label: {
      type: String,
    },
    labelProps: {
      type: Object,
    },
    labelBold: {
      type: Boolean,
      default: () => true,
    },
    value: {
      required: false,
      type: [Number, String],
    },
    id: {
      type: [Number, String],
      default: '',
    },
    placeholder: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    onKeyup: {
      type: Function,
      default: () => {},
    },
    onEnter: {
      type: Function,
      default: () => {},
    },
    options: {
      type: Object,
      default: () => ({
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: true,
      }),
    },
    prefix: {
      type: Boolean,
      default: () => true,
    },
    precision: {
      type: Number,
    },
    max: {
      type: Number,
      default: () => 15,
    },
    suffix: {
      type: String,
      default: () => null,
    },
    description: {
      type: String,
    },
    success: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    returnFormattedValue: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    keyupHandler(params) {
      this.onKeyup(this.id, params);
    },
  },
  computed: {
    ...mapGetters('purchase', ['decimalConfiguration']),
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        if (value !== this.value) {
          if (this.returnFormattedValue) {
            this.$emit('input', value);
          }

          if (!this.returnFormattedValue) {
            this.$emit('input', numberBRToFloat(value));
          }
        }
      },
    },
    inputClass() {
      return {
        success: this.success,
        error: this.error,
      };
    },
    currentPrecison() {
      return this.precision || this.decimalConfiguration.price || this.options.precision;
    },
    formatOptions() {
      return {
        ...this.options,
        prefix: this.prefix ? this.options.prefix : '',
        suffix: this.suffix || '',
        precision: this.currentPrecison,
      };
    },
  },
};
</script>
